import styled, { useTheme } from "styled-components";
import Title from "common/Typography/Title";
import React from "react";
import useUserAvatar from "@shared/common/Avatars/useUserAvatar";
import { userAvatarStyles } from "@shared/common/Avatars/styles";
import { UserAvatarProps } from "@shared/common/Avatars/types";

const UserAvatar = ({
  user,
  avatarSize,
  fallbackInitialsSize,
  isTelegramUser,
}: UserAvatarProps) => {
  const appTheme = useTheme();
  const { imageText } = useUserAvatar(user, isTelegramUser);
  if (user.image) {
    return <UserImage src={user.image} $size={avatarSize} />;
  }

  return (
    <FallbackImage $size={avatarSize}>
      <Title
        level={fallbackInitialsSize}
        style={{ color: appTheme.colors.buttonText }}
      >
        {imageText}
      </Title>
    </FallbackImage>
  );
};

export default UserAvatar;

const UserImage = styled.img<{ $size: number }>`
  ${userAvatarStyles.userImage};
`;

const FallbackImage = styled.div<{ $size: number }>`
  ${userAvatarStyles.fallbackImage};
`;
